import React, { Fragment } from 'react';

import VerticalSectionMarker from 'components/VerticalSectionMarker/VerticalSectionMarker';

const renderDummySections = (sections) => (
  <Fragment>
    {sections.map((section, i) => 
      <section key={`dummy-section-${i}`} id={i} style={{ position: 'absolute', opacity: '0' }}></section>
    )}
  </Fragment>
);

/* eslint-disable react/prop-types */
export const standardLayout = ({ totalItems = 8 }) => {
  const sectionsArray = [];

  for (let i = 0; i < totalItems; i++) {
    sectionsArray.push({ name: `option${i + 1}`, id: i });
  }

  return (
    <Fragment>
      <VerticalSectionMarker title="Title" sections={sectionsArray} />
      {renderDummySections(sectionsArray)}
    </Fragment>
  );
};

export const landingLayout = ({ totalItems = 8, __key = 8 }) => {
  const sectionsArray = [];

  for (let i = 0; i < totalItems; i++) {
    sectionsArray.push({ name: `option${i + 1}`, id: i });
  }

  return (
    <Fragment>
      <VerticalSectionMarker landing sections={sectionsArray} key={__key} />
      {renderDummySections(sectionsArray)}
    </Fragment>
  );
};
/* eslint-enable react/prop-types */


// WEBPACK FOOTER //
// ./src/containers/components/VerticalSectionMarker/constants/verticalSectionMarkerLayouts.js